export const formatUrl = (url: string | null | undefined) => {
  if (!url) {
    return '#';
  }

  if (!url.startsWith('http')) {
    return 'https://' + url;
  }

  return url
}
